import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/firestore'
import 'firebase/storage'
import VueLocalForage from 'vue-localforage'
import _ from '@/assets/lib/my-lodash'
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
}
// Mail Link login setting
const actionCodeSettings = {
  url: process.env.VUE_APP_SITE_URL,
  handleCodeInApp: true
}

firebase.initializeApp(firebaseConfig)
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// バックアップ対象
// 'yagiProfile'は端末ごとに持たせるため除外
const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'format_etc',
  'format_taishokutodoke',
  'basicData',
  'recentEdit',
  LAST_SAVE_DATE_SAVE_KEY
]
const BACKUP_VERSION = 'v20180606-01'
const SITE_ID = process.env.VUE_APP_SITE_ID
const createFirestorePaths = function (uid, docId) {
  if (!uid) {
    console.error('uid not set')
    return {}
  }
  if (!docId) {
    docId = ''
  }
  let paths = {
    userdata: 'userdata',
    userDoc: `userdata/${uid}`,
    backups: `userdata/${uid}/backups`,
    configs: `userdata/${uid}/configs`,
    omikujis: `userdata/${uid}/omikujis`,
    postcards: `userdata/${uid}/postcards`,
    statistics: `serverdata/${uid}/statistics`,
    statisticsOmikuji: `serverdata/${uid}/statistics/omikuji`,
    lightdata: `users/${uid}`
  }
  if (docId) {
    const docPaths = {
      omikujiDoc: `userdata/${uid}/omikujis/${docId}`
    }
    paths = Object.assign(paths, docPaths)
  }
  return paths
}
const CONFIG_DOCUMENT_ID = SITE_ID
const DEFAULT_QUERY_LIMIT_NUM = 10
// BACKUP_QUERY_LIMIT_NUM 分取得
const BACKUP_QUERY_LIMIT_NUM = 10
// BACKUP_SAVE_LIMIT_NUMを超えた分を削除する
const BACKUP_SAVE_LIMIT_NUM = 50
const AUTO_BACKUP_INTERVAL_SECONDS = 60

if (process.env.NODE_ENV === 'development') {
  // AUTO_BACKUP_INTERVAL_SECONDS = 15
  // console.log('NODE_ENV is development so AUTO_BACKUP_INTERVAL_SECONDS is', AUTO_BACKUP_INTERVAL_SECONDS)
  console.log('firebaseConfig', firebaseConfig)
}
const AUTO_BACKUP_INTERVAL_MS = AUTO_BACKUP_INTERVAL_SECONDS * 1000

// OCR利用統計用セッションIDをformDataに付与する共通ヘルパー
function appendOcrSessionId (formData) {
  const ocrSessionId = localStorage.getItem('ocr_session_id')
  if (ocrSessionId) formData.append('ocr_session_id', ocrSessionId)
}

const FirebaseLib = {
  install: function (Vue, options) {
    Vue.use(VueLocalForage)
    const main = new Vue({
      data: function () {
        return {
          accessToken: '',
          db: {},
          user: null,
          userConfig: {},
          lastBackupSaveDate: null,
          lastLocalSaveDate: null,
          autoBackupTimer: null,
          isAddingBackupNow: false,
          isLoginAction: false
        }
      },
      computed: {
        config: function () {
          return firebaseConfig
        },
        authProviderGoogle: function () {
          return new firebase.auth.GoogleAuthProvider()
        },
        isAuthenticated: function () {
          if (this.user && this.user.uid) {
            return true
          } else {
            return false
          }
        },
        firestorePaths: function () {
          if (!this.user || !this.user.uid) {
            return
          }
          return createFirestorePaths(this.user.uid)
        },
        backupStatus: function () {
          if (this.isAddingBackupNow) {
            return {
              type: 'now',
              message: '現在バックアップ中です'
            }
          } else if (this.lastBackupSaveDate) {
            return {
              type: 'done',
              message: this.lastBackupSaveDate
            }
          } else {
            return {
              type: 'none',
              message: ''
            }
          }
        }
      },
      methods: {
        reloadToken: function () {
          const app = this
          return this.user
            .getIdToken(true)
            .then(function (idToken) {
              app.accessToken = idToken
            })
            .catch(function (err) {
              console.error(err)
            })
        },
        createCollectionQuery: function (path, limit) {
          if (!limit) {
            limit = DEFAULT_QUERY_LIMIT_NUM
          }
          return this.db
            .collection(path)
            .where('uid', '==', this.user.uid)
            .where('site', '==', SITE_ID)
            .orderBy('timestamp', 'desc')
            .limit(limit)
        },
        createUnlimitedCollectionQuery: function (path) {
          return this.db
            .collection(path)
            .where('uid', '==', this.user.uid)
            .where('site', '==', SITE_ID)
            .orderBy('timestamp', 'desc')
        },
        createCollectionQuery4Admin: function (path, limit) {
          if (!limit) {
            limit = DEFAULT_QUERY_LIMIT_NUM
          }
          return this.db
            .collection('userdata')
            .limit(10)
        },
        signInApple: function () {
          const provider = new firebase.auth.OAuthProvider('apple.com')
          provider.addScope('email')
          provider.setCustomParameters({
            locale: 'ja'
          })
          firebase.auth().signInWithRedirect(provider)
        },
        signInLine: function () {
          // var provider = new firebase.auth.FacebookAuthProvider();
          // firebase.auth().signInWithRedirect(provider)
          const LENGTH = 16
          const WORDS = 'abcdefghijklmnopqrstuvwxyz0123456789'
          let rString = ''
          for (let i = 0; i < LENGTH; i++) {
            rString += WORDS[Math.floor(Math.random() * WORDS.length)]
          }
          const client_id = process.env.VUE_APP_LINE_CLIENT_ID
          const encoded_cloud_functions_url = encodeURIComponent(process.env.VUE_APP_LINE_CALLBACK_URL)
          location.href = 'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=' + client_id +
            '&redirect_uri=' + encoded_cloud_functions_url +
            '/line-login?action=yagish&scope=profile%20openid%20email&state=' + rString
        },
        signInFacebook: function () {
          const provider = new firebase.auth.FacebookAuthProvider()
          firebase.auth().signInWithRedirect(provider)
        },
        signInGoogle: function () {
          firebase.auth().signInWithRedirect(this.authProviderGoogle)
        },

        logInGoogle: function () {
          firebase.auth().signInWithRedirect(this.authProviderGoogle)
        },
        signOnEmailPasswd: function (id, passwd) {
          const app = this
          firebase.auth().createUserWithEmailAndPassword(id, passwd)
            .then((userCredential) => {
              console.error('createUserWithEmailAndPassword then')
              // Signed in
              const user = userCredential.user
              app.$message({
                message: '会員登録成功しました。',
                type: 'success'
              })
              const formData = new FormData()
              formData.append('uuid', user.uid)
              formData.append('email', user.email)
              const athlete_univ_id = app.$cookies.get('_YAGISH_ATHLETE_UNIVID')
              if (athlete_univ_id) formData.append('athlete_univ_id', athlete_univ_id)
              const affiliate_id = app.$cookies.get('_YAGISH_AFFILIATE_ID')
              if (affiliate_id) formData.append('affiliate_id', affiliate_id)
              formData.append('app_flag', app.$site.appFlag)
              formData.append('site_flag', 'r')
              formData.append('univ_id', '')
              formData.append('email_verified', user.emailVerified ? '1' : '0')
              formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
              appendOcrSessionId(formData)
              app.$axios
                .post(app.$varuna.endPoints.login, formData)
                .then(function (response) {
                  app.$eventHub.$emit('login_redirect_function')
                })
                .catch(function (error) {
                }).finally(function () {
                })
              app.handleDigramExamId(user)
            })
            .catch((error) => {
              const errorCode = error.code
              const errorMessage = error.message
              console.error(errorMessage)
              app.$message({
                message: '登録に失敗しました。' + errorMessage,
                type: 'error'
              })
            })
        },
        signInEmailPasswd: function (id, passwd, errorEvent) {
          console.error('signInEmailPasswd')
          const app = this
          firebase.auth().signInWithEmailAndPassword(id, passwd)
            .then((userCredential) => {
              // Signed in
              const user = userCredential.user
              console.error(user)
              app.$message({
                message: 'ログインに成功しました。',
                type: 'success'
              })
              console.error(9999)
              app.isLoginAction = true
              const formData = new FormData()
              formData.append('uuid', user.uid)
              formData.append('email', user.email)
              const athlete_univ_id = app.$cookies.get('_YAGISH_ATHLETE_UNIVID')
              if (athlete_univ_id) formData.append('athlete_univ_id', athlete_univ_id)
              const affiliate_id = app.$cookies.get('_YAGISH_AFFILIATE_ID')
              if (affiliate_id) formData.append('affiliate_id', affiliate_id)
              formData.append('app_flag', app.$site.appFlag)
              formData.append('site_flag', 'r')
              formData.append('email_verified', user.emailVerified ? '1' : '0')
              formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
              appendOcrSessionId(formData)
              app.$axios
                .post(app.$varuna.endPoints.login, formData)
                .then(function (response) {
                  app.$eventHub.$emit('login_redirect_function')
                })
                .catch(function () {
                }).finally(function () {
                })
              app.handleDigramExamId(user)
            })
            .catch((error) => {
              const errorCode = error.code
              let errorMessage = ''

              switch (errorCode) {
                case 'auth/cancelled-popup-request':
                case 'auth/popup-closed-by-user':
                  errorMessage = null
                  break
                case 'auth/email-already-in-use':
                  errorMessage = 'このメールアドレスは使用されています'
                  break
                case 'auth/invalid-email':
                  errorMessage = 'メールアドレスの形式が正しくありません'
                  break
                case 'auth/user-disabled':
                  errorMessage = 'サービスの利用が停止されています'
                  break
                case 'auth/user-not-found':
                  errorMessage = 'メールアドレスまたはパスワードが違います'
                  break
                case 'auth/user-mismatch':
                  errorMessage = 'メールアドレスまたはパスワードが違います'
                  break
                case 'auth/weak-password':
                  errorMessage = 'パスワードは6文字以上にしてください'
                  break
                case 'auth/wrong-password':
                  errorMessage = 'メールアドレスまたはパスワードが違います'
                  break
                case 'auth/popup-blocked':
                  errorMessage = '認証ポップアップがブロックされました。ポップアップブロックをご利用の場合は設定を解除してください'
                  break
                case 'auth/operation-not-supported-in-this-environment':
                case 'auth/auth-domain-config-required':
                case 'auth/operation-not-allowed':
                case 'auth/unauthorized-domain':
                  errorMessage = '現在この認証方法はご利用頂けません'
                  break
                case 'auth/requires-recent-login':
                  errorMessage = '認証の有効期限が切れています'
                  break
                default:
                  errorMessage = 'エラーが発生しました。しばらく時間をおいてお試しください'
                  break
              }
              app.$eventHub.$emit('set-fullscreen-loading', false)
              app.$message({
                message: 'ログインに失敗しました。' + errorMessage,
                type: 'error'
              })
            })
        },
        signInEmail: function (email) {
          console.error('signInEmail')
          const app = this
          firebase
            .auth()
            .sendSignInLinkToEmail(email, actionCodeSettings)
            .then(function () {
              // The link was successfully sent. Inform the user.
              // Save the email locally so you don't need to ask the user for it again
              // if they open the link on the same device.
              app.$message({
                message: email + 'にログインURLを送りました',
                type: 'success'
              })
              app.$eventHub.$emit('sing-in-mail-send')
              app.$setItem('emailForSignIn', email)
            })
            .catch(function (error) {
              console.error(error)
              app.$message({
                message: 'メールログインが失敗しました',
                type: 'error'
              })
              app.$eventHub.$emit('sing-in-mail-fail')
              // Some error occurred, you can inspect the code: error.code
            })
        },
        signOut: function () {
          const app = this
          firebase
            .auth()
            .signOut()
            .then(function () {
              // Sign-out successful.
              app.$cookies.config(0, '')
              app.$cookies.remove('_YAGISH_SESSION_KEY', null, 'yagish.jp')
              app.$cookies.set('_YAGISH_SESSION_LOGOUT', 'LOGOUT', null, null, 'yagish.jp')
              app.$message({
                message: 'ログアウトしました',
                type: 'info'
              })
              location.href = '/login'
            })
            .catch(function (error) {
              app.$message({
                message: 'ログアウトに失敗しました',
                type: 'error'
              })
              console.error(error)
            })
        },
        deleteUser: function () {
          if (!this.isAuthenticated || !this.user) {
            this.$message({
              message: 'アカウントの削除にはログインが必要です',
              type: 'error'
            })
            return false
          }
          return this.user.delete()
        },
        showResultMessage: function (message, type) {
          this.$message({
            message,
            type,
            duration: 6000
          })
        },
        setupDb: function () {
          this.db = firebase.firestore()
        },
        updateUserDocTimestamp: function () {
          const userDocRef = this.db.doc(this.firestorePaths.userDoc)
          userDocRef.set({
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
          }, {
            merge: true
          })
        },
        loadBackup: function (id) {
          const errors = []
          const app = this
          this.db
            .collection(this.firestorePaths.backups)
            .doc(id)
            .get()
            .then(function (documentSnapshot) {
              if (!documentSnapshot.exists) {
                app.$message({
                  message: 'バックアップデータが見つかりませんでした',
                  type: 'error'
                })
                return
              }
              const data = JSON.parse(documentSnapshot.data().content)
              _.forEach(BACKUP_KEYS_LIST, function (key) {
                if (data.hasOwnProperty(key)) {
                  const dataForLocal = data[key]
                  app.$setItem(key, dataForLocal, function (err) {
                    if (err) {
                      console.error(err)
                      errors.push(err)
                      return
                    }
                    console.log('backup-loaded:', key, dataForLocal)
                    app.$eventHub.$emit('backup-loaded-' + key, dataForLocal)
                  })
                }
              })
              if (errors.length === 0) {
                app.$message({
                  message: 'バックアップを読み込みました:' +
                    documentSnapshot.data().label,
                  type: 'success'
                })
              }
            })
            .catch(function (error) {
              app.$message({
                message: 'バックアップの読み込みに失敗しました',
                type: 'error'
              })
              console.error(error)
            })
        },
        deleteBackup: function (id) {
          return this.db
            .collection(this.firestorePaths.backups)
            .doc(id)
            .delete()
            .then(function () {
              console.log('Document successfully deleted!')
              return true
            })
            .catch(function (error) {
              console.error('Error removing document: ', error)
              return false
            })
        },
        deleteBackupWithMessage: function (id, label) {
          const app = this
          app.db
            .collection(this.firestorePaths.backups)
            .doc(id)
            .delete()
            .then(function () {
              app.$message({
                message: label + 'を削除しました'
              })
              return true
            })
            .catch(function (error) {
              app.$message({
                message: 'バックアップの削除に失敗しました',
                type: 'error'
              })
              console.error('Error removing document: ', error)
              return false
            })
        },
        loadLastBackupSaveDate: function () {
          const app = this
          const query = this.createCollectionQuery(this.firestorePaths.backups, 1)
          return query
            .get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                if (!doc.exists) {
                  console.log('no backup exists')
                  throw new Error('noBackup')
                }
                if (!doc.data().lastSaveDate) {
                  return
                }
                // console.log('doc.data().lastSaveDate', doc.id)
                if (typeof doc.data().lastSaveDate.toDate !== 'undefined') {
                  app.lastBackupSaveDate = doc.data().lastSaveDate.toDate()
                } else {
                  // console.log('lastSaveDate is String', new Date(doc.data().lastSaveDate))
                  app.lastBackupSaveDate = new Date(doc.data().lastSaveDate)
                }
              })
            })
            .catch(function (e) {
              console.error(e)
              throw new Error('queryError', e)
            })
        },
        loadLastLocalSaveDate: function () {
          const app = this
          return this.$getItem(LAST_SAVE_DATE_SAVE_KEY).then(function (data) {
            if (!data) {
              // console.log('no local data exists')
              throw new Error('noLocalData')
            }
            try {
              app.lastLocalSaveDate = new Date(data)
            } catch (e) {
              app.lastLocalSaveDate = data
            }
          })
        },
        needAddingBackup: async function () {
          if (!this.isAuthenticated) {
            return false
          }
          try {
            await this.loadLastBackupSaveDate()
            await this.loadLastLocalSaveDate()
          } catch (e) {
            if (e.message === 'noLocalData') {
              return false
            }
            if (e.message === 'noBackup') {
              return true
            }
            console.error('un expected error on load LastSaveDates', e)
            return false
          }
          // console.log('lastBackupSaveDate', this.lastBackupSaveDate)
          // console.log('lastLocalSaveDate ', this.lastLocalSaveDate)
          if (this.lastLocalSaveDate > this.lastBackupSaveDate) {
            return true
          } else {
            return false
          }
        },
        alertIfNeedsLoadingBackup: async function () {
          if (!this.isAuthenticated) {
            return false
          }
          let errorMessage = ''
          try {
            await this.loadLastBackupSaveDate()
            await this.loadLastLocalSaveDate()
          } catch (e) {
            errorMessage = e.message
            if (errorMessage === 'noBackup') {
              return
            }
          }
          if (!this.lastBackupSaveDate) {
            // console.log('lastBackupSaveDate is empty')
            return
          }
          if (
            errorMessage === 'noLocalData' &&
            this.lastBackupSaveDate.getTime()
          ) {
            // this.$message({
            //   type: 'info',
            //   message: 'サーバーにバックアップがあるよ！'
            // })
            return
          }
          if (this.lastLocalSaveDate.getTime() >= this.lastBackupSaveDate.getTime()) {
            console.log('データは最新です')
            return
          }
          if (this.lastLocalSaveDate < this.lastBackupSaveDate) {
            this.$eventHub.$emit(
              'yagi-message',
              'サーバーに新しいバックアップがあるよ！',
              5000
            )
          }
        },
        getBackupList: function (type, limit) {
          if (!this.isAuthenticated) {
            console.log('getBackupList !this.isAuthenticated')
            return
          }
          let query = this.createCollectionQuery(this.firestorePaths.backups, limit)
          if (type === 'user' || type === 'auto') {
            query = query.where('type', '==', type)
          } else {
            type = 'all'
          }
          return query.get()
        },
        getBackupList4Admin: function (type, limit) {
          const app = this
          if (!this.isAuthenticated) {
            console.log('getBackupList4Admin !this.isAuthenticated')
            return
          }
          let membercount = 0
          let backupcount = 0
          console.log('111')
          const query = this.createCollectionQuery4Admin(this.firestorePaths.backups, limit)
          query.get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                membercount++
                console.log(`membercount/${membercount}/`)
                const userdataPath = `userdata/${doc.id}/backups`
                const subQuery = app.createUnlimitedCollectionQuery(userdataPath)
                subQuery.get()
                  .then(function (subQuerySnapshot) {
                    subQuerySnapshot.forEach(function (doc) {
                      console.log('XX')
                      backupcount++
                      console.log(`backupcount/${backupcount}/`)
                    })
                  }).catch(function (err) {
                    console.log('141414')
                    console.error(err)
                  })
              })
            }).catch(function (err) {
              console.log('444')
              console.error(err)
            })
          return query.get()
        },
        deleteOverLimitBackups: function () {
          if (!this.isAuthenticated) {
            return
          }
          const app = this
          const query = this.createCollectionQuery(this.firestorePaths.backups, 100)
          query
            .get()
            .then(function (querySnapshot) {
              let count = 0
              querySnapshot.forEach(function (doc) {
                const docData = doc.data()
                if (count > BACKUP_SAVE_LIMIT_NUM) {
                  if (docData.type === 'auto') {
                    // console.log('will be deleted', docData.label, count)
                    app.deleteBackup(doc.id)
                    console.log('auto backup deleted', doc.id)
                  }
                }
                count++
              })
            })
            .catch(function (e) {
              console.error(e)
              throw new Error('queryError', e)
            })
        },
        getYagishLightData: async function (id) {
          this.setupDb()
          const app = this
          const query = app.db
            .collection('line_json_data')
            // .where('U677c55b5d9428e28308343927455516d')
            .doc(id)
          const doc = await query.get()
          return doc.data()
        },
        autoBackup: async function () {
          if (!this.isAuthenticated) return
          if (!this.userConfig.autoSave || true) {
            console.log('autobackup skip, autoSave is false')
            return
          }
          // console.log('autobackup start')
          if (await this.needAddingBackup()) {
            let label = '自動バックアップ'
            if (this.$yagi.profile.name) {
              label = this.$yagi.profile.name + 'の' + label
            }
            this.addBackup(label, 'auto')
            console.log('auto addBackup!')
          } else {
            // console.log('autobackup skip needAddingBackup is false')
          }
          this.deleteOverLimitBackups()
        },
        addBackup: async function (label, type = 'user', yagioffer_flag = false, formatId, app_html) {
          this.isAddingBackupNow = true
          if (!this.isAuthenticated) {
            this.$message({
              message: 'ログインしてください',
              type: 'error'
            })
            return
          }
          const storageData = {}
          console.error('await this.$iterateStorage(')
          await this.$iterateStorage(
            function (value, key, iterationNumber) {
              if (_.includes(BACKUP_KEYS_LIST, key)) {
                storageData[key] = value
                console.error(key + '：' + value)
              }
            },
            function (err) {
              if (err) {
                console.error(err)
              }
            }
          )
          if (!storageData) {
            this.$message({
              message: 'データがありません',
              type: 'error'
            })
            return
          }
          // === 同期メタデータの埋め込み ===
          storageData._sync_meta = {
            device: this.$deviceLib.isMobileDevice ? 'SP' : 'PC',
            timestamp: new Date().toISOString(),
            device_id: localStorage.getItem('_device_id')
          }
          const backupData = {
            type,
            label,
            uid: this.user.uid,
            lastSaveDate: storageData.lastSaveDate || null,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            content: JSON.stringify(storageData),
            version: BACKUP_VERSION,
            site: SITE_ID,
            platform: _.compact([this.$deviceLib.platform.name, this.$deviceLib.platform.product, this.$deviceLib.platform.os]).join(', ')
          }

          const app = this
          try {
            const formData = new FormData()
            formData.append('uuid', this.user.uid)
            formData.append('email', this.user.email)
            formData.append('backup_uid', this.user.uid)
            formData.append('site_flag', 'r')
            formData.append('backup_type', type)
            formData.append('backup_name', label)
            formData.append('version', '2')
            formData.append('yagioffer_flag', yagioffer_flag)
            const _bdata = JSON.stringify(storageData)
            // console.error(_bdata)
            // _bdata = _bdata.replace("\u0000", "")
            // console.error(_bdata)
            formData.append('storage_data', _bdata)
            if (formatId.includes('shokumukeirekisho')) {
              formData.append('last_keirekisho_html', app_html)
            } else if (formatId.includes('rerekisho') || formatId.includes('rirekisho') || formatId.includes('rerekisho')) {
              formData.append('last_rirekisho_html', app_html)
            } else {
              formData.append('last_etc_html', app_html)
            }
            formData.append('device_flag', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('email_verified', this.user.emailVerified ? '1' : '0')

            if (this.$globalVar.isRoxx4Rtable) {
              formData.append('roxx_10_flag', '1')
              this.$globalVar.$eventHub.$emit('update_rt_condition', 'roxx_api', 1)
            } else {
              formData.append('roxx_10_flag', '0')
            }
            if (this.$globalVar.isRecruitMc4Rtable) {
              formData.append('auto_rt_id', 'recruit_mc_mail')
              formData.append('auto_rt_type', '3')
              this.$globalVar.$eventHub.$emit('update_rt_condition', 'recruit_mc_mail', this.$globalVar.oldPermissionType4RT)
            }
            if (this.$globalVar.isNeocareer4Rtable) {
              formData.append('auto_rt_id', 'neocareer_admin')
              formData.append('auto_rt_type', '4')
              this.$globalVar.$eventHub.$emit('update_rt_condition', 'neocareer_admin', this.$globalVar.oldPermissionType4RT)
            }
            if (this.$globalVar.isXMile4Rtable) {
              formData.append('auto_rt_id', 'xmile_mail')
              formData.append('auto_rt_type', this.$globalVar.permissionType4RT)
              this.$globalVar.$eventHub.$emit('update_rt_condition', 'xmile_mail', this.$globalVar.oldPermissionType4RT)
            }
            if (this.$globalVar.isPharmate4Rtable) {
              formData.append('auto_rt_id', 'pharmate_mail')
              formData.append('auto_rt_type', this.$globalVar.permissionType4RT)
              this.$globalVar.$eventHub.$emit('update_rt_condition', 'pharmate_mail', this.$globalVar.oldPermissionType4RT)
            }
            if (this.$globalVar.isAutoRT4Rtable) {
              const autoRTInfo = this.$globalVar.autoRTInfo
              if (autoRTInfo.clientId === 'roxx_api' && [17, 18, 19, 20].includes(autoRTInfo.permissionType)) {
                const roxxPermType = autoRTInfo.permissionType
                this.reloadToken().then(() => {
                  if (!this.accessToken) return
                  const roxxFormData = new FormData()
                  roxxFormData.append('token', this.accessToken)
                  roxxFormData.append('apikey', this.config.apiKey)
                  roxxFormData.append('uuid', this.user.uid)
                  roxxFormData.append('format_id', formatId)
                  roxxFormData.append('filename', 'rirekisho_pdf.pdf')
                  roxxFormData.append('app_html', app_html)
                  roxxFormData.append('permission_type', roxxPermType)
                  roxxFormData.append('dialog_name', 'auto_rt')
                  roxxFormData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
                  roxxFormData.append('app_flag', this.$site.appFlag)
                  roxxFormData.append('reqflg', '2')
                  roxxFormData.append('version', '2')
                  this.$axios.post(this.$varuna.endPoints.sendDataRoxx, roxxFormData, { timeout: 60000 })
                })
              } else {
                formData.append('auto_rt_flag', '1')
                formData.append('auto_rt_id', autoRTInfo.clientId)
                formData.append('auto_rt_type', autoRTInfo.permissionType)
              }
              this.$globalVar.$eventHub.$emit('update_rt_condition', autoRTInfo.clientId, autoRTInfo.oldPermissionType)
            }

            formData.append('dialog_name', 'auto_rt_dialog')
            formData.append('format_id', formatId)

            this.$axios.post(this.$varuna.endPoints.saveBackupdata, formData, { timeout: 60000 })

            this.$globalVar.initAutoRT()

            // const backup = await this.db
            //   .collection(this.firestorePaths.backups)
            //   .add(backupData)

            app.$message({
              type: 'success',
              message: '保存成功:' + label
            })
            app.isAddingBackupNow = false
          } catch (error) {
            console.error(error)
            app.$message({
              type: 'error',
              message: '保存失敗:' + label
            })
            app.isAddingBackupNow = false
          }
        },
        addOmikujiLog: async function (omikuji) {
          if (!this.isAuthenticated) {
            console.log('not authenticated, addOmikujiLog skipped')
            return
          }
          if (!omikuji) {
            this.$message({
              message: 'おみくじデータがありません',
              type: 'error'
            })
            return
          }
          const omikujiData = {
            content: omikuji,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            site: SITE_ID
          }
          return this.db.collection(this.firestorePaths.omikujis).add(omikujiData)
        },
        omikujiStatisticsOnSnapshot: function (callback) {
          if (!this.isAuthenticated) {
            console.log('not authenticated, getOmikujiStatistics skipped')
            return
          }
          return this.db.doc(this.firestorePaths.statisticsOmikuji).onSnapshot(callback)
        },
        addPostCard: function (postCard) {
          if (!this.isAuthenticated) {
            return
          }
          if (!postCard) {
            this.$message({
              message: 'はがきの内容がありません',
              type: 'error'
            })
            return
          }
          const postCardData = {
            content: postCard,
            author: {
              uid: this.user.uid,
              email: this.user.email
            },
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            site: SITE_ID
          }
          return this.db
            .collection(this.firestorePaths.postcards)
            .add(postCardData)
        },
        getPostCardList: function (startAfter) {
          if (!this.isAuthenticated) {
            return
          }
          let query = this.db
            .collection(this.firestorePaths.postcards)
            .limit(BACKUP_QUERY_LIMIT_NUM)
            .orderBy('timestamp', 'desc')
          if (startAfter) {
            query = query.startAfter(startAfter)
          }
          return query.get()
        },
        getPostCardListOnSnapshot: function (callback) {
          if (!this.isAuthenticated) {
            return
          }
          const query = this.db
            .collection(this.firestorePaths.postcards)
            .limit(BACKUP_QUERY_LIMIT_NUM)
            .orderBy('timestamp', 'desc')
          return query.onSnapshot(callback)
        },
        loadUserConfig: function () {
          if (!this.isAuthenticated) {
            console.log('not authenticated. loadUserConfig skipped')
            return
          }
          const app = this
          return app.db
            .collection(this.firestorePaths.configs)
            .doc(CONFIG_DOCUMENT_ID)
            .get()
            .then(function (doc) {
              if (doc.exists) {
                app.userConfig = doc.data()
              } else {
                console.log('not config use default')
                app.userConfig = {
                  uid: app.user.uid,
                  autoSave: true
                }
              }
            })
            .catch(function (error) {
              console.log(app.user.uid)
              console.error('Error getting document:', error)
            })
        },
        saveUserConfig: function () {
          if (!this.isAuthenticated) {
            console.log('not authenticated. saveUserConfig skipped')
            return
          }
          const app = this
          const userConfig = app.userConfig
          userConfig.uid = app.user.uid
          return app.db
            .collection(this.firestorePaths.configs)
            .doc(CONFIG_DOCUMENT_ID)
            .set(app.userConfig)
            .then(function () {
              console.log('saveUserConfig success')
            })
            .catch(function (err) {
              console.log('saveUserConfig error:', err)
            })
        },
        activateAutoBackup: function () {
          if (!this.autoBackupTimer) {
            this.autoBackupTimer = setInterval(
              this.autoBackup,
              AUTO_BACKUP_INTERVAL_MS
            )
          } else {
            console.log('autoBackupTimer already exists. skip')
          }
        },
        deactivateAutoBackup: function () {
          clearInterval(this.autoBackupTimer)
        },
        authTest: function () {
          const auth = firebase.functions().httpsCallable('authTest')
          auth({ text: 'test' }).then(function (result) {
            console.log(result)
          }).catch(err => {
            console.error(err)
          })
        },
        handleDigramExamId: function (user) {
          const digramExamId = this.$cookies.get('digram_exam_id')
          this.$cookies.remove('digram_exam_id')
          if (digramExamId && user && user.uid) {
            const formData = new FormData()
            formData.append('random_id', digramExamId)
            formData.append('uuid', user.uid)
            this.$axios.post(this.$varuna.endPoints.loginDigram, formData)
              .then(function (response) {
                console.log(response)
              })
              .catch(function (error) {
                console.error(error)
              })
          }
        },
        init: function () {
          this.setupDb()
          this.loadUserConfig()
          this.activateAutoBackup()
          this.alertIfNeedsLoadingBackup()
          this.updateUserDocTimestamp()
          this.$eventHub.$emit('mailmaga-flag-initialized', this.user)
          this.$eventHub.$emit('yagioffer-flag-initialized', this.user)
          this.$eventHub.$emit('fontpayment-flag-initialized', this.user)
          this.$eventHub.$emit('yagioffer-regist-update', this.user)
          // this.$eventHub.$emit('auth_state_changed', this.user)
          // this.$eventHub.$emit('auth_state_changed_newlogin', this.user)
        }
      }
    })
    firebase
      .auth()
      .getRedirectResult()
      .then(function (result) {
        console.error('getRedirectResult')
        console.error(result)
        if (result.credential) {
          if (result.user.email) {
            main.showResultMessage(
              'ログインしました。：' + result.user.email,
              'success'
            )
            console.error(9999)
            main.isLoginAction = true
            console.error(main.isLoginAction)
            const formData = new FormData()
            formData.append('uuid', result.user.uid)
            formData.append('email', result.user.email)
            var confirm_code = main.$cookies.get('_TEMPDATA_CONFIRM_CODE')
            formData.append('confirm_code', confirm_code)
            var athlete_univ_id = main.$cookies.get('_YAGISH_ATHLETE_UNIVID')
            if (athlete_univ_id) formData.append('athlete_univ_id', athlete_univ_id)
            var affiliate_id = main.$cookies.get('_YAGISH_AFFILIATE_ID')
            if (affiliate_id) formData.append('affiliate_id', affiliate_id)
            formData.append('app_flag', main.$site.appFlag)
            formData.append('site_flag', 'r')
            formData.append('email_verified', result.user.emailVerified ? '1' : '0')
            formData.append('device_flag', main.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            appendOcrSessionId(formData)
            main.$axios
              .post(main.$varuna.endPoints.login, formData)
              .then(function (response) {
                main.$eventHub.$emit('login_redirect_function')
              })
              .catch(function (error) {
              }).finally(function () {
              })
            main.handleDigramExamId(result.user)
          } else {
            main.showResultMessage(
              'ログインしました。',
              'success'
            )
            main.isLoginAction = true
            var confirm_code = main.$cookies.get('_TEMPDATA_CONFIRM_CODE')
            const formData = new FormData()
            formData.append('uuid', result.user.uid)
            formData.append('email', '')
            formData.append('confirm_code', confirm_code)
            var athlete_univ_id = main.$cookies.get('_YAGISH_ATHLETE_UNIVID')
            if (athlete_univ_id) formData.append('athlete_univ_id', athlete_univ_id)
            var affiliate_id = main.$cookies.get('_YAGISH_AFFILIATE_ID')
            if (affiliate_id) formData.append('affiliate_id', affiliate_id)
            formData.append('app_flag', main.$site.appFlag)
            formData.append('site_flag', 'r')
            formData.append('email_verified', result.user.emailVerified ? '1' : '0')
            formData.append('device_flag', main.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            appendOcrSessionId(formData)
            main.$axios
              .post(main.$varuna.endPoints.login, formData)
              .then(function (response) {
                main.$eventHub.$emit('login_redirect_function')
              })
              .catch(function (error) {
              }).finally(function () {
              })
            main.handleDigramExamId(result.user)
          }
        }
      })
      .catch(function (error) {
        main.showResultMessage(
          'ログインに失敗しました：' + error.message,
          'error'
        )
      })
    // router.beforeEach 側で先回りして signInWithEmailLink を消化するため、
    // ここに到達するのは router 経由をすり抜けたフォールバックのみ。
    // 既に currentUser が存在する（= router 側で成功済み）なら重複実行を防ぐ。
    if (firebase.auth().isSignInWithEmailLink(window.location.href) && !firebase.auth().currentUser) {
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      main.$getItem('emailForSignIn').then(function (email) {
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt(
            '別の端末でログインする場合、安全のため再度メールアドレスを入力してください。\n※一度使用したメールリンクは無効となります'
          )
        }
        // main.user は onAuthStateChanged 発火前は null のため null guard 必須
        if (main.user && main.user.email) {
          main.showResultMessage('すでにログイン済みです')
          return
        }
        if (!email) {
          main.showResultMessage('再度ログインし直してください')
          return
        }
        // The client SDK will parse the code from the link for you.
        firebase
          .auth()
          .signInWithEmailLink(email, window.location.href)
          .then(function (result) {
            console.error('signInWithEmailLink')
            // Clear email from storage.
            main.showResultMessage('ログインしました：' + result.user.email)
            main.isLoginAction = true
            main.$removeItem('emailForSignIn')
            const confirm_code = main.$cookies.get('_TEMPDATA_CONFIRM_CODE')
            const formData = new FormData()
            formData.append('uuid', result.user.uid)
            formData.append('email', result.user.email)
            formData.append('confirm_code', confirm_code)
            const athlete_univ_id = main.$cookies.get('_YAGISH_ATHLETE_UNIVID')
            if (athlete_univ_id) formData.append('athlete_univ_id', athlete_univ_id)
            const affiliate_id = main.$cookies.get('_YAGISH_AFFILIATE_ID')
            if (affiliate_id) formData.append('affiliate_id', affiliate_id)
            formData.append('app_flag', main.$site.appFlag)
            formData.append('site_flag', 'r')
            formData.append('email_verified', result.user.emailVerified ? '1' : '0')
            formData.append('device_flag', main.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            appendOcrSessionId(formData)
            main.$axios
              .post(main.$varuna.endPoints.login, formData)
              .then(function (response) {
                main.$eventHub.$emit('login_redirect_function')
              })
              .catch(function (error) {
              }).finally(function () {
              })
            main.handleDigramExamId(result.user)
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
          })
          .catch(function (error) {
            console.error(error)
            main.showResultMessage(
              'ログインに失敗しました。メールリンクを再度送信してください。',
              'error'
            )
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
          })
      })
    }
    // firebase.auth().onAuthStateChanged(function (user) {
    //   main.user = user
    //   main.$yagi.is_logging = true
    //   console.error('firebase-lib onAuthStateChanged')
    //   console.error(user)
    //   if (user) {
    //     var logout_cookie  = main.$cookies.get('_YAGISH_SESSION_LOGOUT')
    //     if (logout_cookie == "LOGOUT" && !main.isLoginAction) {
    //       main.$cookies.remove('_YAGISH_SESSION_LOGOUT', null, 'yagish.jp')
    //       firebase
    //         .auth()
    //         .signOut()
    //     } else {
    //       main.init()
    //       main.$cookies.config(0,'')
    //       main.$cookies.set('_YAGISH_SESSION_KEY', main.user.uid, null, null, 'yagish.jp')
    //     }
    //     main.$yagi.is_logging = false
    //     main.$eventHub.$emit('get_fontpayment')
    //   } else {
    //     main.deactivateAutoBackup()
    //     var login_cookie  = main.$cookies.get('_YAGISH_SESSION_KEY')
    //     if (login_cookie === null) {
    //       main.$yagi.is_logging = false
    //     } else {
    //       const formData = new FormData()
    //       formData.append('uuid', login_cookie)
    //       main.$axios
    //       .post(main.$varuna.endPoints.gettoken, formData)
    //       .then(function (response) {
    //         firebase.auth().signInWithCustomToken(response.data.ct)
    //         .then((userCredential) => {
    //           main.user = userCredential.user
    //           main.$cookies.config(0,'')
    //           main.$cookies.set('_YAGISH_SESSION_KEY', main.user.uid, null, null, 'yagish.jp')
    //           main.$yagi.is_logging = false
    //           main.$eventHub.$emit('get_fontpayment')
    //         })
    //         .catch((error) => {
    //           var errorCode = error.code
    //           var errorMessage = error.message
    //         });
    //       })

    //     }
    //   }
    // })

    firebase.auth().onAuthStateChanged(function (user) {
      console.error('firebase-lib onAuthStateChanged 1134')
      main.user = user
      console.error(user)
      if (user) {
        console.error(user)
        main.init()
        main.$eventHub.$emit('firebase-initialized', this.user)
        main.$cookies.config(0, '')
        main.$cookies.set('_YAGISH_SESSION_KEY', main.user.uid, null, null, 'yagish.jp')
        main.$eventHub.$emit('auth_state_changed', main.user)
        window.WhatapBrowserAgent.setUserID(main.user.uid)
      } else {
        main.$eventHub.$emit('firebase-initialized', this.user)
        main.deactivateAutoBackup()
      }
    })

    main.authReady = new Promise(resolve => {
      firebase.auth().onAuthStateChanged(user => {
        main.user = user
        resolve(user)
      })
    })

    Vue.prototype.$firebase = main
  }
}
export default FirebaseLib
